import html2canvas from 'html2canvas'
const help = {
  // 随机数
  guid () {
    function S4 () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
  },


  getBase64 (img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  },

  // 无限级分类构建树
  ListToTree (list, pid = 'pid', id = 'id', children = 'children', root = '') {
    let tree = []
    if (list instanceof Array) {
      let refer = {}
      list.forEach((el) => {
        el.title = el.name
        el.key = el.id
        el.value = el.id
        refer[el[id]] = el
      })
      Object.keys(refer).forEach((key) => {
        let parentId = refer[key][pid]
        if (root === parentId) {
          tree.push(refer[key])
        } else {
          if (refer[parentId]) {
            if (refer[parentId][children]) {
              refer[parentId][children].push(refer[key])
            } else {
              refer[parentId][children] = [refer[key]]
            }
          }
        }
      })
    }
    return tree
  },

  // 非递归宽度优先遍历
  nonRecursiveWidthFirstTraversal (node) {
    if (!node || !node.children) { return; }
    const arr = []
    let _queue = []; // 借助一个队列
    _queue.push(node);
    while (_queue.length) {
      let _curNode = _queue.shift(); // 推出队头元素
      arr.push(_curNode)
      // 将子节点依次推入队列中
      // _curNode.children.forEach(function (item, index) {
      // 	_queue.push(item);
      // })
      if (_curNode.children.length) {
        _queue = _queue.concat(_curNode.children);
      }
    }
    return arr
  },

  // 过滤对象中值为空的情况
  dataInit (data) {
    // 当对象为formdata类型直接返回对象
    if (Object.prototype.toString.call(data) === '[object FormData]') {
      return data
    }
    // 简易深拷贝
    const str = JSON.stringify(data)
    const newData = JSON.parse(str)
    for (let key in newData) {
      if (!newData[key] && newData[key] !== 0) {
        delete newData[key]
      }
    }
    return newData
  },

  // 数组转字符串
  arrToString (arr, sign = ',') {
    let str = ''
    arr.forEach(item => {
      if (str) {
        str = str + sign + item
      } else {
        str = item
      }
    })
    return str
  },

  // 背景绘制
  drawBackground (element) {

    !function (a) { var b = "object" == typeof self && self.self === self && self || "object" == typeof global && global.global === global && global; "function" == typeof define && define.amd ? define(["exports"], function (c) { b.ParticleNetwork = a(b, c) }) : "object" == typeof module && module.exports ? module.exports = a(b, {}) : b.ParticleNetwork = a(b, {}) }(function (a, b) { var c = function (a) { this.canvas = a.canvas, this.g = a.g, this.particleColor = a.options.particleColor, this.x = Math.random() * this.canvas.width, this.y = Math.random() * this.canvas.height, this.velocity = { x: (Math.random() - .5) * a.options.velocity, y: (Math.random() - .5) * a.options.velocity } }; return c.prototype.update = function () { (this.x > this.canvas.width + 20 || this.x < -20) && (this.velocity.x = -this.velocity.x), (this.y > this.canvas.height + 20 || this.y < -20) && (this.velocity.y = -this.velocity.y), this.x += this.velocity.x, this.y += this.velocity.y }, c.prototype.h = function () { this.g.beginPath(), this.g.fillStyle = this.particleColor, this.g.globalAlpha = .7, this.g.arc(this.x, this.y, 1.5, 0, 2 * Math.PI), this.g.fill() }, b = function (a, b) { this.i = a, this.i.size = { width: this.i.offsetWidth, height: this.i.offsetHeight }, b = void 0 !== b ? b : {}, this.options = { particleColor: void 0 !== b.particleColor ? b.particleColor : "#fff", background: void 0 !== b.background ? b.background : "#1a252f", interactive: void 0 !== b.interactive ? b.interactive : !0, velocity: this.setVelocity(b.speed), density: this.j(b.density) }, this.init() }, b.prototype.init = function () { if (this.k = document.createElement("div"), this.i.appendChild(this.k), this.l(this.k, { position: "absolute", top: 0, left: 0, bottom: 0, right: 0, "z-index": 1 }), /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(this.options.background)) this.l(this.k, { background: this.options.background }); else { if (!/\.(gif|jpg|jpeg|tiff|png)$/i.test(this.options.background)) return console.error("Please specify a valid background image or hexadecimal color"), !1; this.l(this.k, { background: 'url("' + this.options.background + '") no-repeat center', "background-size": "cover" }) } if (!/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(this.options.particleColor)) return console.error("Please specify a valid particleColor hexadecimal color"), !1; this.canvas = document.createElement("canvas"), this.i.appendChild(this.canvas), this.g = this.canvas.getContext("2d"), this.canvas.width = this.i.size.width, this.canvas.height = this.i.size.height, this.l(this.i, { position: "relative" }), this.l(this.canvas, { "z-index": "20", position: "relative" }), window.addEventListener("resize", function () { return this.i.offsetWidth === this.i.size.width && this.i.offsetHeight === this.i.size.height ? !1 : (this.canvas.width = this.i.size.width = this.i.offsetWidth, this.canvas.height = this.i.size.height = this.i.offsetHeight, clearTimeout(this.m), void (this.m = setTimeout(function () { this.o = []; for (var a = 0; a < this.canvas.width * this.canvas.height / this.options.density; a++)this.o.push(new c(this)); this.options.interactive && this.o.push(this.p), requestAnimationFrame(this.update.bind(this)) }.bind(this), 500))) }.bind(this)), this.o = []; for (var a = 0; a < this.canvas.width * this.canvas.height / this.options.density; a++)this.o.push(new c(this)); this.options.interactive && (this.p = new c(this), this.p.velocity = { x: 0, y: 0 }, this.o.push(this.p), this.canvas.addEventListener("mousemove", function (a) { this.p.x = a.clientX - this.canvas.offsetLeft, this.p.y = a.clientY - this.canvas.offsetTop }.bind(this)), this.canvas.addEventListener("mouseup", function (a) { this.p.velocity = { x: (Math.random() - .5) * this.options.velocity, y: (Math.random() - .5) * this.options.velocity }, this.p = new c(this), this.p.velocity = { x: 0, y: 0 }, this.o.push(this.p) }.bind(this))), requestAnimationFrame(this.update.bind(this)) }, b.prototype.update = function () { this.g.clearRect(0, 0, this.canvas.width, this.canvas.height), this.g.globalAlpha = 1; for (var a = 0; a < this.o.length; a++) { this.o[a].update(), this.o[a].h(); for (var b = this.o.length - 1; b > a; b--) { var c = Math.sqrt(Math.pow(this.o[a].x - this.o[b].x, 2) + Math.pow(this.o[a].y - this.o[b].y, 2)); c > 120 || (this.g.beginPath(), this.g.strokeStyle = this.options.particleColor, this.g.globalAlpha = (120 - c) / 120, this.g.lineWidth = .7, this.g.moveTo(this.o[a].x, this.o[a].y), this.g.lineTo(this.o[b].x, this.o[b].y), this.g.stroke()) } } 0 !== this.options.velocity && requestAnimationFrame(this.update.bind(this)) }, b.prototype.setVelocity = function (a) { return "fast" === a ? 1 : "slow" === a ? .33 : "none" === a ? 0 : .66 }, b.prototype.j = function (a) { return "high" === a ? 5e3 : "low" === a ? 2e4 : isNaN(parseInt(a, 10)) ? 1e4 : a }, b.prototype.l = function (a, b) { for (var c in b) a.style[c] = b[c] }, b });

    var canvasDiv = document.getElementById(element);
    var options = {
      particleColor: '#888',
      background: 'http://tech.imrpress.com/static/demo-bg.jpg',
      interactive: true,
      speed: 'medium',
      density: 'high'
    };
    var particleCanvas = new ParticleNetwork(canvasDiv, options);
  },

  // 自定义列表预处理
  createTableList (obj) {
    const tableList = {}
    const arr = []
    const keys = []
    delete obj.isSuccess
    for (let key in obj) {
      if (key.includes('_arr')) {
        const newkey = key
        tableList[newkey] = {
          title: obj[key].key,
          dataIndex: newkey,
          key: newkey,
          width: 400,
          scopedSlots: { customRender: 'arr' },
        }
        arr[obj[key].value] = {
          title: obj[key].key,
          dataIndex: newkey,
          key: newkey,
          width: 400,
          scopedSlots: { customRender: 'arr' },
        }
        keys[obj[key].value] = newkey
      } else {
        tableList[key] = {
          title: obj[key].key,
          dataIndex: key,
          width: 300,
          key,
          scopedSlots: { customRender: 'remark' },
        }
        arr[obj[key].value] = {
          title: obj[key].key,
          dataIndex: key,
          width: 300,
          key,
          scopedSlots: { customRender: 'remark' },
        }
        keys[obj[key].value] = key
      }
    }
    Object.assign(tableList, {
      num: {
        title: '序号',
        dataIndex: 'num',
        key: 'num',
        width: 60,
        scopedSlots: { customRender: 'num' },
      }, arr, keys, remark: {
        title: '备注',
        dataIndex: 'remark',
        key: 'remark',
        scopedSlots: { customRender: 'remark' },
      }, action: {
        title: '操作',
        key: 'action',
        width: 100,
        fixed: 'right',
        scopedSlots: { customRender: 'action' },
      }
    })
    return tableList
  },

  // 无闪现下载excel
  download (url, filename) {
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
  },

  // 图片转换格式的方法 直接使用就好  不需要知道为什么
  dataURLToBlob (dataurl) {
    let arr = dataurl.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: mime })
  },

  /* 保存图片的方法（即按钮点击触发的方法）
    第一个参数为需要保存的div的id名
    第二个参数为保存图片的名称 */
  saveImage (dom, imgText = '测试') {
    let that = this
    let a = document.createElement('a')
    return html2canvas(dom, {
      logging: false,
      scale: 4
    }).then(canvas => {
      let dom = document.body.appendChild(canvas)
      dom.style.display = 'none'
      a.style.display = 'none'
      document.body.removeChild(dom)
      let blob = that.dataURLToBlob(dom.toDataURL('image/png'))
      // console.log(dom.toDataURL('image/png'))
      // console.log(URL.createObjectURL(blob))
      a.setAttribute('href', URL.createObjectURL(blob))
      // 这块是保存图片操作  可以设置保存的图片的信息
      a.setAttribute('download', imgText + '.png')
      document.body.appendChild(a)
      a.click()
      URL.revokeObjectURL(blob)
      document.body.removeChild(a)
    })
  },

  funDownload (content, filename) {
    // 创建隐藏的可下载链接
    var eleLink = document.createElement('a');
    eleLink.download = filename;
    eleLink.style.display = 'none';
    // 字符内容转变成blob地址
    var blob = new Blob([content]);
    eleLink.href = URL.createObjectURL(blob);
    // 触发点击
    document.body.appendChild(eleLink);
    eleLink.click();
    // 然后移除
    document.body.removeChild(eleLink);
  },

  // 12月列表

  months: [{
    name: 'January',
    num: '1'
  }, {
    name: 'February',
    num: '2'
  }, {
    name: 'March',
    num: '3'
  }, {
    name: 'April',
    num: '4'
  }, {
    name: 'May',
    num: '5'
  }, {
    name: 'June',
    num: '6'
  }, {
    name: 'July',
    num: '7'
  }, {
    name: 'August',
    num: '8'
  }, {
    name: 'September',
    num: '9'
  }, {
    name: 'October',
    num: '10'
  }, {
    name: 'November',
    num: '11'
  }, {
    name: 'December',
    num: '12'
  }],

  // quill配置菜单
  editorOption: {
    modules: {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'], //加粗，斜体，下划线，删除线
        ['blockquote', 'code-block'],  //引用，代码块


        [{ 'header': 1 }, { 'header': 2 }],  // 标题，键值对的形式；1、2表示字体大小
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],  //列表
        [{ 'script': 'sub' }, { 'script': 'super' }], // 上下标
        [{ 'indent': '-1' }, { 'indent': '+1' }],  // 缩进
        [{ 'direction': 'rtl' }],    // 文本方向  

        [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],  //几级标题


        [{ 'color': [] }, { 'background': [] }],  // 字体颜色，字体背景颜色
        [{ 'font': [] }],  //字体
        [{ 'align': [] }], //对齐方式

        ['link'], // 超链接
        ['clean'], //清除字体样式
        ['image', 'video', 'formula'] //上传图片、上传视频
      ]
    },
    theme: 'snow'
  },

  // JSON格式化
  format2Json (str) {
    var json = {};
    if (!str) { return json; }
    var result = str.replace(/(['"]?)[\r\n\s]*(\w+)[\r\n\s]*\1[\r\n\s]*(:)[\r\n\s]*([^{},\[\]]+)?/g, function (item, quote, key, delimiter, value) {
      //双引号包裹
      quote = "\"";
      key = quote + key + quote;
      if (value) {
        if (/^(['"])[\s\S]*\1$/.test(value)) {
          value = value.replace(/^(['"])([\s\S]*)\1$/, function (item, g1, g2) {
            g1 = quote;
            return g1 + help.escape(g2) + g1;
          });
        } else {
          if (/^[-+]?(?:[1-9]\d*|0)(?:\.\d+)?$/.test(value)) {
            value = (+value);
          } else {
            value = quote + help.escape(value) + quote;
          }
        }
      } else {
        value = "";
      }
      return key + delimiter + value;
    });
    try {
      json = JSON.parse(result);
    } catch (e) {
      return json;
    }
    return json;
  },
  escape (str) {
    if (!str) { return ""; }
    var escapes = {
      "\n": '\\n',
      "\"": '\\"',
      "\\": '\\\\',
      "\b": '\\b',
      "\f": '\\f',
      "\r": '\\r',
      "\t": '\\t'
    };
    return str.replace(/["\n\r\\\b\f\t]/g, function (item) {
      return escapes[item];
    });
  },

  // 获取元素相对页面的绝对位置
  getElementLeft (element) {
    var actualLeft = element.offsetLeft;
    var current = element.offsetParent;
    while (current !== null) {
      actualLeft += (current.offsetLeft + current.clientLeft);
      current = current.offsetParent;
    }
    return actualLeft;
  },
  getElementTop (element) {
    var actualTop = element.offsetTop;
    var current = element.offsetParent;
    while (current !== null) {
      actualTop += (current.offsetTop + current.clientTop);
      current = current.offsetParent;
    }
    return actualTop;
  },
}

export default help